window.tdTabs = [];

document.addEventListener("DOMContentLoaded", () => {
	const tabs = document.querySelectorAll('.tab-section');
	let delay = 0;
	tabs.forEach(tabBlock => {
		let tabInfo = [];
		let tabBlockId = tabBlock.getAttribute('data-tab-group');
		let tabSections = tabBlock.querySelectorAll("[data-tab]");

		tabInfo['autoplay'] = tabBlock.getAttribute('data-autoplay');
		tabInfo['showNavigationButtons'] = tabBlock.getAttribute('data-show-navigation-buttons');
		tabInfo['tag'] = tabBlock;
		tabInfo['currentTab'] = 0;
		tabInfo['tabs'] = tabSections;
		tabInfo['tabOrder'] = [];
		tabSections.forEach((t, i) => {
			tabInfo['tabOrder'][i] = t.getAttribute('data-tab');
		});
		window.tdTabs[tabBlockId] = tabInfo;

		if(tabInfo['autoplay'] === 'true') {
			setTimeout(() => { tdTabsSetAutoplay(tabBlockId) }, delay);
			delay += 1000;
		}
	});
});

window.tdTabsSetAutoplay = function(tabBlockId) {
	const tabBlock = tdTabs[tabBlockId];
	if(!tabBlock) return;

	if(tabBlock['autoplay'] === 'true') {
		clearInterval(tabBlock['interval']);
		tabBlock['interval'] = setInterval(() => {
			if(!tabBlock['tag'].matches(':hover')) {
				tdNextTab(tabBlockId);
			}
		}, 6000);
	} else {
		clearInterval(tabBlock['interval']);
	}
}

window.tdNextTab = function(tabBlockId) {
	let tabBlock = tdTabs[tabBlockId];
	let tabNum = tabBlock['currentTab'];

	tabNum++;
	if(tabNum >= tabBlock['tabs'].length) {
		tabNum = 0;
	}
	tabBlock['currentTab'] = tabNum;
	tdSwitchTab(tabBlockId, tabBlock['tabOrder'][tabNum]);
};

window.tdPrevTab = function(tabBlockId) {
	let tabBlock = tdTabs[tabBlockId];
	let tabNum = tabBlock['currentTab'];

	tabNum--;
	if(tabNum < 0) {
		tabNum = tabBlock['tabs'].length - 1;
	}
	tabBlock['currentTab'] = tabNum;
	tdSwitchTab(tabBlockId, tabBlock['tabOrder'][tabNum]);
};


window.tdSwitchTab = function(tabBlockId, tabId) {
	const tabBlock = tdTabs[tabBlockId] || false;
	if(!tabBlock) return;

	const tabSections = tabBlock['tabs'];
	if(tabSections.length === 0) return;

	tabSections.forEach(tabSection => {
		let tab = tabBlock['tag'].querySelector('[data-tab-id="' + tabSection.getAttribute('data-tab') + '"] .tab-section-tab');
		if(tabSection.getAttribute('data-tab') === tabId) {
			tab.classList.add('active');
			tab.classList.remove('inactive');
			tabSection.classList.add('flex');
			tabSection.classList.remove('hidden');
			tabBlock['currentTab'] = tabBlock['tabOrder'].indexOf(tabId);
			tdTabsSetAutoplay(tabBlockId);
		} else {
			tab.classList.remove('active');
			tab.classList.add('inactive');
			tabSection.classList.remove('flex');
			tabSection.classList.add('hidden');
		}
	});

}
